import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import OfferBanner from "@/components/OfferBanner";
import Services from "@/components/Services";
import PriceList from "@/components/PriceList";
import PricingCalculator from "@/components/PricingCalculator";
import BeforeAfter from "@/components/BeforeAfter";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import Careers from "@/components/Careers";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FAF8F5] font-sans text-[#121A16] antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <OfferBanner />
        <Services />
        <PriceList />
        <PricingCalculator onBook={setPrefill} />
        <BeforeAfter />
        <Manifesto />
        <Testimonials />
        <Careers />
        <BookingForm prefill={prefill} />
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
    </div>
  );
}
